import { render, staticRenderFns } from "./ConfirmDeleteDialog.vue?vue&type=template&id=3e1ffa61&scoped=true&lang=pug&"
import script from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteDialog.vue?vue&type=style&index=0&id=3e1ffa61&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ffa61",
  null
  
)

/* custom blocks */
import block0 from "./ConfirmDeleteDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports